import * as _accessors from './accessors';
import * as _actions from './actions';
import _reducer from './reducer';
import _StudentUnitResources, {
  ResourceResult as _ResourceResult,
  ResourceTypes as _ResourceTypes,
  ResourceLabels as _ResourceLabels,
  ResourceStatus as _ResourceStatus,
  ResourceColumnOrder as _ResourceColumnOrder,
  ResourceDisplayCategory as _ResourceDisplayCategory,
  getResourceDisplayCategory as _getResourceDisplayCategory,
} from './model';

export const accessors = _accessors;
export const actions = _actions;
export const reducer = _reducer;
export const StudentUnitResources = _StudentUnitResources;
export const ResourceResult = _ResourceResult;
export const ResourceTypes = _ResourceTypes;
export const ResourceLabels = _ResourceLabels;
export const ResourceStatus = _ResourceStatus;
export const ResourceColumnOrder = _ResourceColumnOrder;
export const ResourceDisplayCategory = _ResourceDisplayCategory;
export const getResourceDisplayCategory = _getResourceDisplayCategory;



// WEBPACK FOOTER //
// ./data/UnitResources/index.js